import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { PromotionCardProps } from '../../../components/PromotionCard/PromotionCard';
import { transformContentCardCommonData } from '../article-card-transformer/article-card-transformer';

const transformPromotionCard = (data: CMSTransformerDataType): PromotionCardProps => {
  const transformedContentCommonDetail = transformContentCardCommonData(data);
  let transformedContentDetail = {};
  if (data) {
    transformedContentDetail = {
      subTitleLineOne: data?.sub_title_1,
      subTitleLineTwo: data?.sub_title_2,
    };
  }

  return {
    componentType: ComponentType.promotion_card,
    ...transformedContentCommonDetail,
    ...transformedContentDetail,
  };
};

export default transformPromotionCard;
